import React, { useState } from 'react'
import Lightbox from 'react-image-lightbox'

const Details = props => {
  const { data } = props
  const [lbIsOpen, setLbIsOpen] = useState(false)
  const [photoIndex, setPhotoIndex] = useState(0)
  const openLb = index => {
    setPhotoIndex(index)
    setLbIsOpen(true)
  }


  return (
    <div className={'details'}>
      <div className="description">
        <h1><span className={'date'}>{data.year}</span>{data.name}</h1>
        <h2><span className={'desc1'}>
          {data.description1.split('\n').map((item, key) => {
            return <React.Fragment key={key}>{item}<br/></React.Fragment>
          })}</span>
          <span className={'desc2'}>{data.description2}</span></h2>
      </div>
      <div className={'gallery'}>
        {data.images.map( (img, index) => <figure onClick={() => openLb(index)}><img key={index} src={"/images/new/" + img } /></figure> )}
      </div>





      {lbIsOpen && (
        <Lightbox
          imageTitle={data.name + ' (' + (photoIndex+1) + '/' + data.images.length + ')'}
          mainSrc={"/images/new/" + data.images[photoIndex]}
          nextSrc={data.images[(photoIndex + 1) % data.images.length]}
          prevSrc={data.images[(photoIndex + data.images.length - 1) % data.images.length]}
          onCloseRequest={() => setLbIsOpen(false)}
          onMovePrevRequest={() => setPhotoIndex((photoIndex + data.images.length - 1) % data.images.length)}
          onMoveNextRequest={() => setPhotoIndex((photoIndex + 1) % data.images.length)}
        />
      )}
    </div>
  )
}

export default Details